import React from 'react';
import { Button } from './ui/button';
import { Download } from 'lucide-react';

export const WhyPlaySection = () => {
  const features = [
    { icon: '🃏', title: 'Truco Mineiro ou Paulista', highlight: false },
    { icon: '🏆', title: 'Evolua no ranking', subtitle: 'Sistema competitivo', highlight: true },
    { icon: '⚡', title: 'Partidas rápidas', subtitle: 'Menos de 5 min', highlight: true },
    { icon: '🎯', title: 'Eventos semanais', subtitle: 'Com premiações', highlight: true },
    { icon: '🤝', title: 'Comunidade unida', subtitle: 'Em crescimento', highlight: false },
  ];

  const badges = [
    { icon: '🛡️', text: 'Segurança' },
    { icon: '📲', text: 'Interface moderna' },
    { icon: '🔄', text: 'Atualizações frequentes' }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-[#05050A] relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-1/2 left-0 w-64 h-64 bg-green-primary/30 rounded-full blur-[100px]"></div>
        <div className="absolute top-1/2 right-0 w-64 h-64 bg-purple-primary/30 rounded-full blur-[100px]"></div>
      </div>

      <div className="relative z-10 px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-8 lg:mb-12 max-w-2xl mx-auto">
          <p className="overline mb-2">Benefícios</p>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black font-archive text-white mb-3">
            Se você gosta de Truco, aqui você pode:
          </h2>
          <p className="text-sm sm:text-base text-gray-400">
            Plataforma criada para quem realmente gosta de Truco
          </p>
        </div>

        {/* Mobile: Horizontal Carousel */}
        <div className="lg:hidden">
          <div className="snap-carousel hidden-scrollbar -mx-4">
            {features.map((feature, index) => (
              <div
                key={index}
                className={`w-[200px] flex-shrink-0 first:ml-4 last:mr-4`}
              >
                <div className={`game-card p-4 rounded-2xl h-full text-center ${
                  feature.highlight 
                    ? 'border-green-primary/40 bg-gradient-to-b from-green-primary/10 to-transparent' 
                    : 'border-gray-700/30'
                }`}>
                  {feature.highlight && (
                    <div className="absolute -top-2 right-2">
                      <span className="bg-green-primary text-[8px] text-white font-bold px-2 py-0.5 rounded-full">
                        ★
                      </span>
                    </div>
                  )}
                  <div className="text-3xl mb-3">{feature.icon}</div>
                  <h3 className="text-sm font-bold text-white mb-1">{feature.title}</h3>
                  {feature.subtitle && (
                    <p className="text-xs text-gray-400">{feature.subtitle}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
          <p className="text-center text-xs text-gray-500 mt-4">
            ← Deslize para ver mais →
          </p>
        </div>

        {/* Desktop: Compact Grid */}
        <div className="hidden lg:grid grid-cols-5 gap-4 max-w-4xl mx-auto mb-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`game-card p-5 rounded-2xl text-center transition-transform hover:scale-105 ${
                feature.highlight 
                  ? 'border-green-primary/40 bg-gradient-to-b from-green-primary/10 to-transparent' 
                  : 'border-gray-700/30'
              }`}
            >
              <div className="text-4xl mb-3">{feature.icon}</div>
              <h3 className="text-sm font-bold text-white mb-1">{feature.title}</h3>
              {feature.subtitle && (
                <p className="text-xs text-gray-400">{feature.subtitle}</p>
              )}
            </div>
          ))}
        </div>

        {/* Badges Row */}
        <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4 max-w-2xl mx-auto">
          {badges.map((badge, index) => (
            <div 
              key={index}
              className="flex items-center gap-2 px-4 py-2 rounded-full bg-black/30 border border-gray-700/30"
            >
              <span className="text-lg">{badge.icon}</span>
              <span className="text-xs sm:text-sm text-gray-300">{badge.text}</span>
            </div>
          ))}
        </div>

        {/* Mid-page CTA */}
        <div className="text-center mt-10">
          <Button 
            data-testid="why-play-cta"
            className="btn-neon px-8 py-5 rounded-xl font-bold text-base"
          >
            <Download className="mr-2 h-5 w-5" />
            Baixar Grátis
          </Button>
        </div>
      </div>
    </section>
  );
};
